<div class="tags-container properties" ng-controller="TagsController as tagsCtrl">
    <header>
        <h1>{{'tag.header'|translate}}</h1>
        <p class="form-description">{{'tag.usage.description'|translate}}</p>
    </header>

    <c-tree-explorer class="display-tree" config="tagsCtrl.treeConfig"></c-tree-explorer>
</div>